const QUIZ_COLORS = {
  // Accent Colors (Blue - 일반/강조)
  accent: "blue-600",
  accentLight: "blue-500",
  accentDark: "blue-700",
  accentBg: "blue-50",
  // Success Colors (Green - 정답)
  success: "green-600",
  successLight: "green-500",
  successDark: "green-700",
  successBg: "green-50",
  // Danger Colors (Red - 오답)
  danger: "red-600",
  dangerLight: "red-500",
  dangerDark: "red-700",
  dangerBg: "red-50",
  // Surface Colors
  surfaceBase: "white",
  surfaceMuted: "gray-50",
  surfaceSecondary: "gray-100",
  // Text Colors
  textPrimary: "gray-900",
  textSecondary: "gray-700",
  textMuted: "gray-500",
  textTertiary: "gray-400"
};
const QUIZ_OPTION_STATES = {
  default: "border-gray-200 bg-white",
  hover: "hover:border-blue-400 hover:bg-blue-50",
  selected: "border-blue-500 bg-blue-100 text-blue-700 font-semibold",
  correct: "border-green-500 bg-green-50 text-green-700",
  wrong: "border-red-500 bg-red-50 text-red-700",
  disabled: "border-gray-200 bg-gray-50 opacity-60"
};
const QUIZ_OX_STYLES = {
  container: "flex gap-6 justify-center py-6",
  button: "flex flex-col items-center gap-4 p-6 border-2 border-gray-200 rounded-xl bg-white w-full max-w-[200px] transition-all duration-200",
  buttonHover: "hover:border-blue-500 hover:-translate-y-1 hover:shadow-md",
  buttonSelected: "border-blue-500 bg-blue-50",
  buttonCorrect: "border-green-500 bg-green-50",
  buttonWrong: "border-red-500 bg-red-50",
  mark: "w-20 h-20 rounded-full flex items-center justify-center text-6xl font-extrabold bg-gray-100 text-gray-400 transition-all",
  markSelected: "bg-blue-500 text-white",
  markCorrect: "bg-green-500 text-white",
  markWrong: "bg-red-500 text-white",
  label: "text-2xl font-semibold text-gray-600",
  labelSelected: "text-blue-700",
  labelCorrect: "text-green-700",
  labelWrong: "text-red-700"
};
const QUIZ_INLINE_STYLES = {
  base: "inline-flex items-center justify-center min-h-9 h-auto py-1 align-middle bg-white border border-gray-300 rounded-lg mx-1 px-3 text-lg font-semibold text-gray-900 transition-all text-center outline-hidden",
  input: "w-auto px-2 cursor-text",
  inputPlaceholder: "placeholder:text-gray-400 placeholder:font-normal",
  inputFocus: "focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
  select: "cursor-pointer",
  selectFocus: "focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
  box: "cursor-pointer",
  boxEmpty: "text-gray-400 font-normal",
  boxFilled: "border-blue-500 bg-blue-50 text-blue-700",
  correct: "border-green-500 bg-green-50 text-green-700",
  wrong: "border-red-500 bg-red-50 text-red-700"
};
const QUIZ_CHIP_STYLES = {
  base: "min-w-[60px] px-4 py-1 bg-white border border-blue-500 text-blue-500 rounded-full font-medium transition-all shadow-2xs",
  hover: "hover:bg-blue-500 hover:text-white hover:-translate-y-0.5",
  used: "bg-gray-100 border-transparent text-gray-400 cursor-default shadow-none",
  disabled: "cursor-default opacity-70"
};
const QUIZ_FEEDBACK_STYLES = {
  correct: {
    container: "bg-linear-to-r from-green-50 to-emerald-50 border border-green-500",
    icon: "bg-green-500",
    title: "text-green-700",
    text: "text-green-600"
  },
  wrong: {
    container: "bg-linear-to-r from-red-50 to-rose-50 border border-red-500",
    icon: "bg-red-500",
    title: "text-red-700",
    text: "text-red-600"
  }
};
const QUIZ_EXPLANATION_STYLES = {
  toggleButton: "w-full flex justify-between items-center bg-blue-100 border-none text-gray-900 px-6 py-4 rounded-lg text-lg font-semibold cursor-pointer transition-all hover:brightness-95",
  area: "w-full p-6 rounded-xl bg-white border border-gray-400 text-gray-600 leading-relaxed",
  areaCorrect: "bg-green-50 border-green-500",
  areaWrong: "bg-red-50 border-red-500"
};
const QUIZ_BUTTON_STYLES = {
  primary: "bg-blue-600 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-colors hover:bg-blue-700",
  primaryDisabled: "bg-gray-200 text-gray-400 cursor-not-allowed",
  secondary: "bg-gray-100 text-gray-400 px-8 py-4 rounded-xl text-lg font-semibold border-none hover:brightness-95"
};
const QUIZ_NAV_STYLES = {
  item: "w-10 h-10 rounded-full flex items-center justify-center font-bold text-base transition-all border-none bg-gray-200 text-gray-900",
  active: "bg-gray-900 text-white scale-110 shadow-2xs",
  correct: "bg-green-500 text-white",
  wrong: "bg-red-500 text-white"
};
export {
  QUIZ_BUTTON_STYLES,
  QUIZ_CHIP_STYLES,
  QUIZ_COLORS,
  QUIZ_EXPLANATION_STYLES,
  QUIZ_FEEDBACK_STYLES,
  QUIZ_INLINE_STYLES,
  QUIZ_NAV_STYLES,
  QUIZ_OPTION_STATES,
  QUIZ_OX_STYLES
};
//# sourceMappingURL=quiz-styles.js.map
